import React, { useEffect } from "react";

export function ContactDetails(props) {

  const handleWdeClick = (e, command) => {
    e.preventDefault();
    if (window._genesys) _genesys.widgets.bus.command(command);
  }

  return (
    <div className="contact-details" id="contact-details">
      <h2 className="h1">{props.data.title}</h2>
      <div className="contact-details__list">

        {props.wdeData.webchatAvailable && props.data.webchatEnabled &&
          <a href="#"
            onClick={(e) => {
              handleWdeClick(e, "WebChat.open"); 
            }}
            className="contact-details__list-item">
            <div className="contact-details__list-icon">
              <i className={`agi agi-f-webchat`}></i>
            </div>
            <div className="contact-details__list-text">
              {props.data.webchatSubtitle?.length > 0 &&
                <small>{props.data.webchatSubtitle}</small>
              }
              <p>{props.data.webchatTitle}</p>
            </div>
          </a>
        }

        {props.wdeData.callbackAvailable && props.data.callbackEnabled &&
          <a href="#"
            onClick={(e) => {
              handleWdeClick(e, "Callback.open");          
            }}
            className="contact-details__list-item">
            <div className="contact-details__list-icon">
              <i className={`agi agi-phone-c`}></i>
            </div>
            <div className="contact-details__list-text">
              {props.data.callbackSubtitle?.length > 0 &&
                <small>{props.data.callbackSubtitle}</small>
              }
              <p>{props.data.callbackTitle}</p>
            </div>
          </a>
        }

        {
          props.data.items.map((item, i) => (

            <a key={i}
              href={item.href}
              className="contact-details__list-item">
              <div className="contact-details__list-icon">
                <i className={`agi ${item.iconId}`}></i>
              </div>
              <div className="contact-details__list-text">
                {item.subtitle?.length > 0 &&
                  <small>{item.subtitle}</small>
                }
                <p>{item.title}</p>
              </div>
            </a>

          ))
        }

      </div>
    </div>
  );
}
